import { z } from 'zod';
import type { TFunction } from 'i18next';
import { optionalOrEmpty } from '@/shared/utils/schemaHelpers';

const orgNameField = (t: TFunction) =>
  z.string().min(2, t('organizations:errors.nameMin')).max(50, t('organizations:errors.nameMax'));

const orgSlugField = (t: TFunction) =>
  z
    .string()
    .min(2, t('organizations:errors.slugMin'))
    .max(50, t('organizations:errors.slugMax'))
    .check(z.regex(/^[a-z0-9-]+$/, { error: t('organizations:errors.slugInvalid') }));

export const createOrganizationSchema = (t: TFunction) =>
  z.object({
    name: orgNameField(t),
    slug: orgSlugField(t),
    color: z.string().min(1, t('organizations:errors.colorRequired')),
  });

export type CreateOrganizationInput = z.infer<ReturnType<typeof createOrganizationSchema>>;

export const updateOrganizationInfoSchema = (t: TFunction) =>
  z.object({
    name: orgNameField(t),
    slug: orgSlugField(t),
    description: z.string().max(500, t('organizations:errors.descriptionMax')).optional(),
    websiteUrl: optionalOrEmpty(z.url({ error: t('organizations:errors.websiteUrlInvalid') })),
    color: z.string().min(1, t('organizations:errors.colorRequired')),
  });

export type UpdateOrganizationInfoInput = z.infer<ReturnType<typeof updateOrganizationInfoSchema>>;
